import React from 'react';
import { useTranslation } from "react-i18next";
import BackContainer from './components/backContainer';
import TicketHeader from './components/header';
import UrlContainer from './components/urlContainer';
import ResaleBreakdown from './components/resaleBreakdown';
import Message  from './components/message';
import EditResale from './edit';
import './resale.css';


export default function ResaleMenu({onSubmit = () => {}, config}) {
    const { t } = useTranslation();
    const { id: attendeeId } = config['resale-menu'].header;
    const [state, setState] = React.useState({'price': config['resale-menu'].resale_breakdown.price.value, 'is_private_resale': Boolean(config['resale-menu'].resale_option.url)});
    const [editResale, setEditResale] = React.useState(false);

    const goToTicket = React.useCallback(() => {
        onSubmit({
            data: {
                action: 'TicketMenuStep',
                payload: {
                    attendee_id: attendeeId
                }
            }
        })
    }, [onSubmit, attendeeId]);
    
    const goToOrderMenu = React.useCallback(() => {
        onSubmit({
            data: {
                action: 'OrderMenuStep',
            }
        })
    }, [onSubmit]);

    return (
        <div className='resale-container'>
            {
                !editResale ? (
                    <>
                        <BackContainer title={t('widget.resale.back-title')} onClick={goToTicket}/>
                        {config['resale-menu'].message && <Message 
                            type='success'
                            title={config['resale-menu'].message.title} 
                            description={config['resale-menu'].message.body}
                            link={{
                                label: config['resale-menu'].message.button,
                                onClick: goToOrderMenu
                            }}
                        />}
                        <TicketHeader data={config['resale-menu'].header} state={state}/>
                        {config['resale-menu'].resale_option.url &&  <UrlContainer data={config['resale-menu']} state={state} onSubmit={onSubmit}/>}
                        <ResaleBreakdown data={config['resale-menu']} state={state} setState={setState} mode='resale-menu' goToTicket={goToTicket} setEditResale={setEditResale} onSubmit={onSubmit} />
                    </>
                ) : <EditResale/>
            }
        </div>
    )
}